import { memo, useMemo } from "react";
import clsx from "clsx";

import classes from "./styles.module.scss";

import { DashboardCard } from "@components/molecules/dashboardCard";
import { Subtitle } from "@components/atoms/subtitle";
import { BaseLoader } from "@components/molecules/baseLoader";
import type { IDashboardSummaryProps } from "@components/organisms/dashboardSummary/types";

export const DashboardSummary = memo(function DashboardSummary({
  items,
  title,
  isLoading,
  isError,
}: IDashboardSummaryProps) {
  const itemsComponent = useMemo(
    () => items?.map((item) => <DashboardCard card={item} key={item.key} />),
    [items],
  );

  return (
    <>
      <Subtitle title={title || "summary"} />
      <BaseLoader
        type={"dashboard-card"}
        isLoading={isLoading}
        isError={isError}
      >
        <div className={clsx(classes.cardRow)}>{itemsComponent}</div>
      </BaseLoader>
    </>
  );
});
